import React from "react";
import { useRecoilValue } from 'recoil'

import { loacLayerAtom } from './atoms'
import { supergroups, groups } from './metadata'

export default function LoacLegend() {
	const loacLayer = useRecoilValue(loacLayerAtom)

	const renderSelectedLayerLegend = () => {
		if (loacLayer.value === 'group') {
			return groups.map(renderGroup)
		}

		if (loacLayer.value === 'supergroup') {
			return supergroups.map(renderGroup) 
		}

		return null
	}

	const renderGroup = (g) => {
		return (
			<div style={{
				display: "flex",
				gap: 8,
				paddingLeft: 22,
				paddingRight: 8,
				marginRight: 16,
				lineHeight: 1.3,
			}}>
				<span style={{
					flexShrink: 0,
					marginTop: 2,
					background: g.color,
					width: 16,
					height: 16,
				}}>
				</span>
				{g.id}: {g.name}
			</div>
		)
	}

 	return (
		<div style={{
			marginBottom: 12,
		}}>
			{loacLayer && renderSelectedLayerLegend()}
		</div>
	)
}